import { Web3Modal, Web3Button, useWeb3Modal, Web3ModalProps } from '@web3modal/react';
import { configureChains,Connector, useDisconnect, useWalletClient, createConfig, WagmiConfig, useConnect, useChainId, useAccount, useNetwork, useConfig } from 'wagmi';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Web3 from 'web3';
import web3Config from '../../../Web3/web3Config';
import { Warning } from '../../../../utils/errors';
import * as ACTIONTYPES from '../../../../redux/actionTypes'


const Connectwalletsecond = ({ loginDetails, show, onHide }) => {
    const dispatch = useDispatch();
    const _useWeb3Modal = useWeb3Modal()
    const _useNetwork = useNetwork()
    
    const _useConnect = useConnect()
    const _useChainId = useChainId()
    const _useAccount = useAccount()
    const _useWalletClient = useWalletClient()
    const _useConfig = useConfig()
    const _useDisconnect = useDisconnect()

    // console.log({
    //     _useDisconnect,
    //     _useNetwork,
    //     _useWalletClient,
    //     _useConfig,
    //     _useConnect,
    //     _useChainId,
    //     _useAccount,
    // })
    useEffect(() => {
        // getProvider()
    }, [_useAccount])

    const getProvider = async () => {
        let aa = await _useAccount.connector?.getProvider()
         console.log({aa : aa, _useWalletClient: _useWalletClient.data})
        // if(!_useWalletClient.data && _useAccount.isConnected){
        //     // _useDisconnect.disconnect()
        //     // Warning(`Please select ${web3Config.NETWORK} network`)
        //     return;
        // }
        // console.log({aa : _useAccount.connector})
        // let aa = await _useAccount?.connector?.options?.getProvider()
        if (aa) {
            const web3 = new Web3(aa);
            let pp = await web3.currentProvider.chainId;
            console.log({ aa, pp, _useChainId, aa1: aa.chainId })

            // if (parseInt(web3Config.CHAIN) != web3.utils.toHex(parseInt(pp))) {
            //     _useDisconnect.disconnect()
            //     console.log('dissss, aa')
            // } else {
                dispatch({ type: ACTIONTYPES.walletConnnected, payload: _useAccount.address });
            // }
        }
    }
    
    useEffect(() => {
        if (!_useWeb3Modal.isOpen) {
            onHide()
        }
    }, [_useWeb3Modal])



    useEffect(() => {
        if (_useAccount.isConnected) {
            // if (parseInt(web3Config.CHAIN) != _useChainId) {
                //     _useDisconnect.disconnect()
                //     Warning(`Please select ${web3Config.NETWORK} network`)
            // } else {
                dispatch({ type: ACTIONTYPES.walletConnnected, payload: _useAccount.address });
            // }
        } else {
            dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
            console.log('Disconnected')
        }

    }, [_useAccount])



    useEffect(() => {
        if (show) {
            _useWeb3Modal.open()
        }
    }, [show])





    return (
        <>
        </>
    );
}

export default Connectwalletsecond;
